"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TranslationsContextProvider", {
  enumerable: true,
  get: function get() {
    return _TranslationsContextProvider.TranslationsContextProvider;
  }
});
Object.defineProperty(exports, "useTranslationsContext", {
  enumerable: true,
  get: function get() {
    return _TranslationsContextProvider.useTranslationsContext;
  }
});

var _TranslationsContextProvider = require("./TranslationsContextProvider");